import {useInstantSearch} from "react-instantsearch";
import {type ReactNode} from "react";
import {useConfigContext} from "@/ConfigProvider";

interface NoResultsBoundaryProps {
    children: ReactNode;
    fallback: ReactNode;
}

export function NoResultsBoundary({children, fallback}: NoResultsBoundaryProps) {
    const {results} = useInstantSearch();
    if (!results.__isArtificial && results.nbHits === 0) {
        return (
            <>
                {fallback}
                <div hidden>{children}</div>
            </>
        );
    }
    return children ? <>{children}</> : null;
}

export function NoResults() {
    const {indexUiState} = useInstantSearch();
    const {tc,algoliaConfig: {isSearch, isFundingPage}} = useConfigContext();

    const hasActiveFilters = !!(indexUiState.refinementList &&
        Object.values(indexUiState.refinementList).some(v => v.length > 0));

    if (!isSearch && !hasActiveFilters) {
        return (
            <div className="warningbox">
                {tc.noAlgoliaArticlesInCategory}
            </div>
        );
    }

    // isSearch is always true on the funding page, even before the visitor has
    // typed anything into the funding search box. In that case, skip the
    // "no results found for ''" phrasing and just show a plain "no results" message.
    if (isFundingPage && !indexUiState.query) {
        return (
            <div className="emptybox">
                {tc.search_sites_no_result}
            </div>
        );
    }

    return (
        <div className="emptybox">
            {isSearch ? tc.noEntriesFoundForSearch : tc.noEntriesFoundForCategory}
            {isSearch &&
            <q>{indexUiState.query}</q>}
        </div>
    );
}